import React from 'react';
import { DatabaseIcon, CogIcon, LayersIcon, BarChart2Icon } from 'lucide-react';
const Slide4 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2676">
      <div className="flex flex-col space-y-6" data-id="element-2677">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-8" data-id="element-2678">How it works</h2>
        {/* Steps */}
        <div className="max-w-4xl mx-auto" data-id="element-2679">
          <div className="relative" data-id="element-2680">
            {/* Connection line */}
            <div className="absolute left-[42px] top-12 bottom-12 w-1 bg-indigo-200 hidden md:block" data-id="element-2681"></div>
            <div className="space-y-12" data-id="element-2682">
              {/* Step 1 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2683">
                <div className="flex-shrink-0 flex items-start" data-id="element-2684">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2685">
                    <DatabaseIcon className="h-8 w-8" data-id="element-2686" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2687">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2688">
                    1. Ingest & normalize catalog
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2689">
                    We connect to your product catalog through APIs or feeds,
                    then normalize and enrich the data for optimal AI
                    understanding.
                  </p>
                  <div className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2690">
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2691">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2692"></div>
                      <span data-id="element-2693">Product data</span>
                    </div>
                    <div className="h-2" data-id="element-2694"></div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2695">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2696"></div>
                      <span data-id="element-2697">Inventory & availability</span>
                    </div>
                    <div className="h-2" data-id="element-2698"></div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2699">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2700"></div>
                      <span data-id="element-2701">Pricing & promotions</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Step 2 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2702">
                <div className="flex-shrink-0 flex items-start" data-id="element-2703">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2704">
                    <CogIcon className="h-8 w-8" data-id="element-2705" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2706">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2707">
                    2. Consultative engine → best fit
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2708">
                    Our AI engine uses consultative selling techniques to
                    understand customer needs and match them with the best
                    products.
                  </p>
                  <div className="flex flex-wrap gap-2 mb-3" data-id="element-2709">
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2710">
                      Bundles
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2711">
                      Filters
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2712">
                      Coupons
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2713">
                      Subscriptions
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2714">
                      Loyalty-aware
                    </span>
                  </div>
                </div>
              </div>
              {/* Step 3 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2715">
                <div className="flex-shrink-0 flex items-start" data-id="element-2716">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2717">
                    <LayersIcon className="h-8 w-8" data-id="element-2718" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2719">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2720">
                    3. Orchestrate channels
                  </h3>
                  <p className="text-gray-700" data-id="element-2721">
                    We deploy your AI shopping advisors across all customer
                    touchpoints, ensuring consistent experiences and seamless
                    handoffs.
                  </p>
                </div>
              </div>
              {/* Step 4 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2722">
                <div className="flex-shrink-0 flex items-start" data-id="element-2723">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2724">
                    <BarChart2Icon className="h-8 w-8" data-id="element-2725" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2726">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2727">
                    4. Measure & optimize
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2728">
                    Continuous improvement through analytics, A/B testing, and
                    learning from customer interactions.
                  </p>
                  <div className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2729">
                    <div className="space-y-2" data-id="element-2730">
                      <div data-id="element-2731">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2732">
                          <span data-id="element-2733">Conversion Rate</span>
                          <span data-id="element-2734">+24%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2735">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '74%'
                        }} data-id="element-2736"></div>
                        </div>
                      </div>
                      <div data-id="element-2737">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2738">
                          <span data-id="element-2739">Average Order Value</span>
                          <span data-id="element-2740">+18%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2741">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '68%'
                        }} data-id="element-2742"></div>
                        </div>
                      </div>
                      <div data-id="element-2743">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2744">
                          <span data-id="element-2745">Customer Satisfaction</span>
                          <span data-id="element-2746">92%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2747">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '92%'
                        }} data-id="element-2748"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide4;